// LucideSidebarIcons.js
// Centralized Lucide icon mapping for sidebar
import {
  LayoutDashboard,
  CalendarClock,
  Percent,
  BadgePercent,
  Layers,
  Ruler,
  ArrowLeftRight,
  Eye,
  FileText,
  ShoppingCart,
  Users,
  Package,
  Building,
  CreditCard,
  Tag,
  FolderTree,
  Warehouse,
  Book,
  BookOpen,
  DollarSign,
  CreditCard as Money,
  BarChart2,
  LineChart,
  Settings,
  User,
  ClipboardList,
  LogOut,
  FileBarChart,
  File,
  ListChecks,
  ShieldCheck,
  FileSearch,
  FileSignature,
  FileSpreadsheet,
  FileText as FileTextAlt,
  UserCheck,
  UserCog,
  Users as UsersAlt,
  FileClock,
  FileWarning,
  FileX,
  FilePlus,
  FileMinus,
  FileEdit,
  FileLock,
  FileUnlock,
  FileArchive,
  FileStack,
  FileUp,
  FileDown,
  FileOutput,
  FileInput,
  FileCheck,
  FileSearch2,
  FileList,
  FileBarChart2,
  FilePieChart,
  FilePieChart2,
  FilePieChart3,
  FilePieChart4,
  FilePieChart5,
  FilePieChart6,
  FilePieChart7,
  FilePieChart8,
  FilePieChart9,
  FilePieChart10,
  FilePieChart11,
  FilePieChart12,
  FilePieChart13,
  FilePieChart14,
  FilePieChart15,
  FilePieChart16,
  FilePieChart17,
  FilePieChart18,
  FilePieChart19,
  FilePieChart20,
  FilePieChart21,
  FilePieChart22,
  FilePieChart23,
  FilePieChart24,
  FilePieChart25,
  FilePieChart26,
  FilePieChart27,
  FilePieChart28,
  FilePieChart29,
  FilePieChart30,
  FilePieChart31,
  FilePieChart32,
  FilePieChart33,
  FilePieChart34,
  FilePieChart35,
  FilePieChart36,
  FilePieChart37,
  FilePieChart38,
  FilePieChart39,
  FilePieChart40,
  FilePieChart41,
  FilePieChart42,
  FilePieChart43,
  FilePieChart44,
  FilePieChart45,
  FilePieChart46,
  FilePieChart47,
  FilePieChart48,
  FilePieChart49,
  FilePieChart50,
  FilePieChart51,
  FilePieChart52,
  FilePieChart53,
  FilePieChart54,
  FilePieChart55,
  FilePieChart56,
  FilePieChart57,
  FilePieChart58,
  FilePieChart59,
  FilePieChart60,
  FilePieChart61,
  FilePieChart62,
  FilePieChart63,
  FilePieChart64,
  FilePieChart65,
  FilePieChart66,
  FilePieChart67,
  FilePieChart68,
  FilePieChart69,
  FilePieChart70,
  FilePieChart71,
  FilePieChart72,
  FilePieChart73,
  FilePieChart74,
  FilePieChart75,
  FilePieChart76,
  FilePieChart77,
  FilePieChart78,
  FilePieChart79,
  FilePieChart80,
  FilePieChart81,
  FilePieChart82,
  FilePieChart83,
  FilePieChart84,
  FilePieChart85,
  FilePieChart86,
  FilePieChart87,
  FilePieChart88,
  FilePieChart89,
  FilePieChart90,
  FilePieChart91,
  FilePieChart92,
  FilePieChart93,
  FilePieChart94,
  FilePieChart95,
  FilePieChart96,
  FilePieChart97,
  FilePieChart98,
  FilePieChart99,
  FilePieChart100
} from 'lucide-react';

export const LucideSidebarIcons = {
  // Fallback for any nav item without its own mapping below — kept distinct
  // from the Dashboard item's own icon so retheming one doesn't retheme
  // every unmapped item in the sidebar along with it.
  Default: LayoutDashboard,
  Dashboard: LineChart,
  Overview: Eye,
  Invoices: FileText,
  Orders: ShoppingCart,
  Customers: Users,
  'Purchase Orders': Package,
  Suppliers: Building,
  Bills: CreditCard,
  Stock: Package,
  Products: Tag,
  'Product Categories': FolderTree,
  'Product Types': Layers,
  'Units of Measure': Ruler,
  'Operation Types': ArrowLeftRight,
  'Weigh & Measure': Ruler,
  Warehouses: Warehouse,
  'General Ledger': Book,
  'Accounts Payable': DollarSign,
  'Accounts Receivable': Money,
  'Sales Reports': FileBarChart,
  'Customer Reports': FileBarChart,
  'Purchasing Reports': FileBarChart,
  'Product Integrity': FileBarChart,
  'Accounting Reports': FileBarChart,
  'Platform Reports': FileBarChart,
  'Custom Reports': FileBarChart,
  Analytics: BarChart2,
  'Payment Terms': CalendarClock,
  'Price Adjustment Rules': Percent,
  'Price Adjustments': BadgePercent,
  Pricelists: FileSpreadsheet,
  'Customer Price Groups': FolderTree,
  'Product Price Groups': FolderTree,
  Settings: Settings,
  'Sales Settings': Settings,
  'Customer Setup': Settings,
  'Purchasing Settings': Settings,
  'Inventory Settings': Settings,
  'Accounting Settings': Settings,
  'Receivables Settings': Settings,
  'Payment Options': Settings,
  'Warehouse Settings': Settings,
  'Platform Settings': Settings,
  Users: User,
  'Document Types': File,
  'Audit Log': ClipboardList,
  Manual: BookOpen,
  'Screen Help Settings': Settings,
  'New Invoice': ClipboardList,
  'New Product': Tag,
  Logout: LogOut,
};
